// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tp-0";
export var checkoutRateBadgeLink = "_tp-1";